import { COLORS } from '../theme';

export default function getSvgFill(color: string): string {
  if (color === 'currentColor') return color;

  const [col, val] = color.split('.');
  return COLORS[col][val];
}
